import debug from 'bows';
import mediaQueries from './_media-queries';

const log = debug('dropdown');

export default class {
	constructor(node, opts = {}) {
		this.node = node;
		this.opened = false;

		this.opts = Object.assign({
			class: 'nav__menu-item--open',
			delay: 300,
		}, opts);

		this.enterTimeout = null;
		this.leaveTimeout = null;

		this.node.addEventListener('mouseenter', (e) => {
			if ( window.matchMedia( mediaQueries.medium_up ).matches ) {
				// only apply this on desktop
				log('mouseenter', e, window.matchMedia( mediaQueries.medium_down ).matches);

				// clear the leave timeout so we don't close
				if (typeof this.leaveTimeout === 'number') {
					window.clearTimeout(this.leaveTimeout);
				}

				// set the enter timeout to open after the delay
				this.enterTimeout = window.setTimeout(() => {
					this.open();
				}, this.opts.delay);
			}
		});

		this.node.addEventListener('mouseleave', (e) => {
			if (window.matchMedia( mediaQueries.medium_up ).matches) {
				// only apply this on desktop
				log('mouseleave', e, window.matchMedia( mediaQueries.medium_down ).matches);

				if (typeof this.enterTimeout === 'number') {
					// clear the enter timeout so we don't open
					window.clearTimeout(this.enterTimeout);
				}

				// set the leave timeout to close after the delay
				this.leaveTimeout = window.setTimeout(() => {
					this.close();
				}, this.opts.delay);
			}
		});

		// handle touch events
		this.node.addEventListener('touchstart', (e) => {
			if (window.matchMedia(mediaQueries.medium_up).matches) {
				// only on desktop version

				if (this.opened === false && e.target.parentNode === this.node) {
					// open the menu if we're not touching a sub item
					log('touch toggle');
					e.preventDefault();
					e.stopPropagation();
					return this.open();
				}

				// stop the propagation so the click events don't fire on links and close the menu
				if ( e.target.tagName === 'A' ) {
					log('touch menu link');
					e.stopPropagation();
				}
			}
		});

		// static listen callback for off-clicking the document to close the dropdown
		this.listen = (e) => {
			let node = e.target;
			const nodes = [ node ];

			// built a list of all parent nodes from the initial node
			while(node.parentNode) {
				nodes.push(node);
				node = node.parentNode;
			}

			// close the menu if the primary node isn't in the list of parent nodes
			if ( nodes.indexOf( this.node ) === -1 ) {
				this.close();
			}
		}
	}

	open() {
		log('open');
		this.opened = true;
		this.node.classList.add(this.opts.class);
		this.node.dispatchEvent( new Event( 'dropdown.open' ) ); // dispatch an event so the conroller of all dropdowns know when to close other items
		document.addEventListener('click', this.listen); // start listening for off click
	}

	close() {
		log('close');
		this.opened = false;
		this.node.classList.remove(this.opts.class);
		this.node.dispatchEvent( new Event( 'dropdown.close' ) ); // dispatch an event so the conroller of all dropdowns know when to close other items
		document.removeEventListener('click', this.listen); // stop listening for off click
	}

	toggle() {
		log('toggle');
		return this.opened ? this.close() : this.open();
	}
}
